import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { archiveBoard } from "../../../../sevices/apiBoards";
import { objectToFormData } from "../../../../utils";
import { changeExpand } from "../../../../redux/boardListSlice";
import { useCustomSearchParams } from "../../../../hooks/useCustomSearchParams";
import UploadCSV from "./uploadCSV/UploadCSV";
import MergeBoard from "../mergeBoard/MergeBoard";
import useToastPromise from "../../../../hooks/useToast";

import DesktopArchiveMenu from './Archive/DesktopArchiveMenu';
import ArchiveDialog from './Archive/ArchiveDialog';
import ManageFields from './Archive/ManageFields';
import useBoardIdByKey from "../../../../hooks/useBoardIdByKey";

function Archive({ isOwner, isAdmin, boardId }) {
  const { id } = useBoardIdByKey();
  const { id:key } = useParams();
  const queryClient = useQueryClient();
  const cachedData = queryClient.getQueryData(["boardName", id]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [archiveDialog, setArchiveDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [paramsWorklogs, setParamsWorklogs] = useCustomSearchParams("worklogs");
  const [openCSV, setOpenCSV] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isArchive = cachedData?.data?.data?.responseData?.is_archive;
  const [openMergeBoard, setOpenMergeBoard] = useState(false);
  const [openManageFields, setOpenManageFields] = useState(false);
  const { showToastPromise } = useToastPromise();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseDialog = () => {
    setArchiveDialog(false);
  };

  const handleCSV = () => {
    setOpenCSV(true);
  };

  const open = Boolean(anchorEl);

  const { mutate: archiveMutate } = useMutation({
    mutationFn: async (data) => {
      return await showToastPromise(archiveBoard, data);
    },
    onSuccess: (res) => {
      queryClient.invalidateQueries({
        queryKey: ["boards"],
      });
      dispatch(changeExpand(isArchive ? "panel1" : "panel2"));
      queryClient.invalidateQueries({
        queryKey: ["boardName", id],
      });
      setLoading(false);
      handleCloseDialog();
    },
    onError: (error) => {
      console.error("Error Delete Attachments", error);
      setLoading(false);
      handleCloseDialog();
    },
  });

  const handleNavigate = (boardNumber) => {
    setParamsWorklogs("worklogs", "true");
  };

  const handleNavigateFeed = (boardId) => {
    navigate(`/feeds/${key}`);
  };

  const callback = () => {
    const data = objectToFormData({ is_archive: !isArchive, board_id: id });
    setLoading(true);
    archiveMutate({ id, data });
  };

  const handleMergeBoard = () => {
    setOpenMergeBoard(true);
  };

  const handleManageFields = () => {
    setOpenManageFields(true);
  };

  return (
    <>
      <DesktopArchiveMenu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClick}
        isAdmin={isAdmin}
        isOwner={isOwner}
        isArchive={isArchive}
        onArchiveClick={() => setArchiveDialog(true)}
        onFeedClick={() => handleNavigateFeed(boardId)}
        onWorklogsClick={() => handleNavigate(boardId)}
        onCSVClick={handleCSV}
        onMergeBoardClick={handleMergeBoard}
        onManageFieldsClick={handleManageFields}
      />
      {archiveDialog && (
        <ArchiveDialog
          open={archiveDialog}
          onClose={handleCloseDialog}
          onSubmit={callback}
          loading={loading}
          isArchive={isArchive}
        />
      )}
      {openCSV && <UploadCSV openCSV={openCSV} closeCSV={setOpenCSV} />}
      {openMergeBoard && (
        <MergeBoard
          close={setOpenMergeBoard}
          open={openMergeBoard}
          currentBoard={cachedData}
        />
      )}
      {openManageFields && (
        <ManageFields
          open={openManageFields}
          close={() => setOpenManageFields(false)}
          currentBoard={cachedData}
        />
      )}
    </>
  );
}

export default Archive;
